export default "__VITE_ASSET__c3d74223__"